import React, { useEffect, useState } from 'react'
import { EditPage } from '@equipedigitalfloripa/ed-cms/components'
// import { EditPage } from '../components/EditPage'
import * as JuridicoApi from '../api/juridico'
import { useSelector } from 'react-redux'

const EditJuridico = ({ edit }) => {
  const translations = useSelector(state => state.translations.translations)
  const juridicoTranslations = translations['system-juridico']


  const selectedData = [
    {
      name: '_id',
      type: 'hidden',
      title: 'Id'
    },
    {
      name: 'name',
      type: 'text',
      title: "Nome do Jurídico",
      validation: {
        required: true
      },
      options: {
        maxLength: '150'
      },
    },
    {
      name: 'description',
      type: 'tiny',
      title: "Pequena descrição do Juridico",
    },
    
    {
      name: 'image',
      type: 'dragdrop',
      title: 'Imagem',
      options: {
        maxFiles: 1
      },
      validation: {
        required: true
      },
    },
  ]
  return (
    <EditPage
      title={edit ? "Editar Juridico" : "Adicionar Serviço"}
      subtitle={edit ? "Alterando informações do Juridico" : "Adicionando informações do Juridico"}
      selectedData={selectedData} 
      addFunction={JuridicoApi.addItem}
      fetchFunction={JuridicoApi.fetchItem}
      editFunction={JuridicoApi.editItem}
      uploadFunction={JuridicoApi.uploadJuridico}
      edit={edit}
      url='juridico'
    />
  )
}

export default EditJuridico
